<template>
  <div class="search-result">
    <Aheader :realIndex="0"></Aheader>
    <div class="banner">
      <p>search result</p>
    </div>
    <div class="content">
      <p class="path">
        <router-link to="/home">Home Page</router-link>
        <span style="color:#999"> / </span>
        <span> Search Result </span>
      </p>
      <div class="box">
        <div v-for="item in species" :key="item.index" class="item">
          <div class="img-box">
            <img
              @click="toDetail(item)"
              :src="item.img || baseImg"
              alt=""
              :class="{ imgFull: item.img }"
            />
            <p v-if="!item.img" style="cursor: default;">No picture</p>
          </div>
          <p @click="toDetail(item)" class="name">
            <span style="font-style: italic;">{{ item.italicName }}</span
            ><span>{{ item.notItalicName }}</span>
          </p>
        </div>
      </div>
    </div>
    <div class="pagination">
      <Paging :total="total" :page.sync="page" :limit="6"></Paging>
    </div>
    <Afooter></Afooter>
  </div>
</template>

<script>
import http from '../../utils/http'
import { Message } from 'element-ui'
import Aheader from '../../components/aheader.vue'
import Paging from '../../components/paging.vue'
import Afooter from '../../components/afooter.vue'
import Img from '../../assets/img/search-base1.png'

export default {
  name: 'HomeSearch',
  components: {
    Aheader,
    Paging,
    Afooter
  },
  data () {
    return {
      species: [],
      page: 1,
      total: 0,
      baseImg: Img
    }
  },
  created () {
    this.$store.commit('toTop')
    // 获取数据
    this.getData()
  },
  methods: {
    // 获取数据
    getData () {
      http.get(
        `/speciesList?name=${this.$route.query.input}&currentPage=${this.page}&pageSize=6`,
        {},
        res => {
          if (res.code === 200) {
            res.data.species.forEach((item, index) => {
              item.img = ''
            })
            this.species = res.data.species
            this.total = res.data.total

            this.species.forEach(item => {
              // 获取图片
              http.get(`/speciesGetImg?id=${item.id}`, {}, res1 => {
                if (res1.code === 200) {
                  item.img = res1.data
                } else {
                  Message.error(`${res.msg}`)
                }
              })
            })
            this.species.forEach(ele => {
              let obj = this.$utils.getItalic(ele.name)
              ele.italicName = obj.italicName
              ele.notItalicName = obj.notItalicName
            })
          } else {
            Message.error(`${res.msg}`)
          }
        }
      )
    },
    // 转到详情页
    toDetail (item) {
      if (item.isOpen === 1) {
        this.$router.push(
          `/home/detail?input=${this.$route.query.input}&id=${item.id}`
        )
      } else {
        Message.error('The species is not public')
      }
    }
  },
  watch: {
    page (newal, oldal) {
      // 请求数据
      this.page = newal
      this.getData()
    }
  }
}
</script>

<style lang="scss" scoped>
.search-result {
  box-sizing: border-box;
  min-width: vw(1200);
}
.banner {
  margin-top: vw(81);
  min-width: vw(1200);
  height: vw(356);
  background-image: url('../../assets/img/search-banner.png');
  background-size: 100% 100%;
  padding-top: vw(130);
  box-sizing: border-box;
  p {
    width: vw(1200);
    margin: 0 auto;
    font-size: vw(42);
    color: #ffffff;
  }
}
.content {
  width: vw(1200);
  margin: 0 auto;
  box-sizing: border-box;
  padding-top: vw(25);

  .path {
    color: #333;
    font-size: vw(16);
    margin-bottom: vw(52);
    a {
      color: #999;
      &:hover {
        color: $theme_color;
      }
    }
  }

  .box {
    display: flex;
    flex-wrap: wrap;
    .item {
      color: #333;
      width: vw(362);
      margin: 0 vw(17) vw(91);
      border: 1px solid #dddddd;
      border-radius: 6px;
      transition: 0.3s;
      bottom: 0;
      position: relative;
      .img-box {
        background-color: rgb(202, 204, 206);
        width: vw(362);
        height: vw(230);
        margin-bottom: vw(20);
        box-sizing: border-box;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        > p {
          margin-top: 20px;
          font-size: 20px;
          color: #fff;
        }
        .imgFull {
          width: 100%;
          height: 100%;
          cursor: pointer;
        }
      }
      .name {
        font-size: vw(16);
        margin-bottom: vw(27);
        padding-left: vw(19);
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        cursor: pointer;
        &:hover {
          color: $theme_color;
        }
      }
      &:hover {
        box-shadow: 0px 8px 30px 0px rgba(0, 4, 60, 0.05);
        bottom: 10px;
      }
    }
  }
}
.pagination {
  text-align: center;
  margin-bottom: vw(119);
}
</style>



// WEBPACK FOOTER //
// src/views/home/homeSearch.vue